import PropTypes from 'prop-types';

const basicShape = {
  code: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  price: PropTypes.string,
  validity: PropTypes.string,
  effectDate: PropTypes.string,
  expirationDate: PropTypes.string,
  offerCode: PropTypes.string,
  offerName: PropTypes.string,
  offerPrice: PropTypes.string,
  paymentMethods: PropTypes.arrayOf(
    PropTypes.oneOf(['CONTRASALDO', 'CONTRAFACTURA', 'WEBPAY', 'WOMPAY'])
  ),
};

export default PropTypes.shape({
  ...basicShape,
  combo: PropTypes.arrayOf(PropTypes.shape({ ...basicShape })),
});
